import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import React, { useState, forwardRef, useEffect } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import config from "../../../../config";
import { qs, useInfiniteScroll } from "../../../../utils"; // Components

import Package from "../../../../components/Package";
import { saveRecentSearch } from "../../../../components/UserMenu";
import Advertising from "../../../../components/Advertising";
import "./Results.scss";
var PACKAGES_PER_PAGE = 12;
export var Results = forwardRef(function (a, b) {
  var c = a.sortBy,
      d = a.onlyLotsResults,
      e = a.style,
      f = _objectWithoutProperties(a, ["sortBy", "onlyLotsResults", "style"]),
      g = f.packages || [],
      h = useState(g.slice(0, PACKAGES_PER_PAGE)),
      i = _slicedToArray(h, 2),
      j = i[0],
      k = i[1],
      l = useInfiniteScroll(function () {
    j.length === g.length || setTimeout(function () {
      k(function (a) {
        var b = a.length + PACKAGES_PER_PAGE,
            c = g.slice(0, b);
        return c;
      }), n(!1);
    }, 10);
  }, {
    offset: 400
  }),
      m = _slicedToArray(l, 2),
      n = m[1],
      o = window.location.pathname,
      p = "jubilee" === config.api.get("project") || "urban-square" === config.api.get("neighbourhood"),
      q = qs.parse(window.location.search);

  q.sort || (q.sort = d || q.sort || !p ? q.sort : "price");
  var r = q.sort,
      s = q.similar_properties;
  useEffect(function () {
    if (!s) {
      var a = _objectSpread({}, q);

      delete a.sort;
      var b = qs.stringify(_objectSpread({}, a, {
        type: d ? "land" : a.type
      }));
      saveRecentSearch(b);
    }
  }, [d, q, s]), useEffect(function () {
    k(g.slice(0, PACKAGES_PER_PAGE));
  }, [g]); // @NOTE for featuredPriceParams since featured is the default
  // by making sort undefined (removing it from the url)
  // it will work out of the box

  var t = qs.stringify(_objectSpread({}, q, {
    sort: "featured"
  })),
      u = qs.stringify(_objectSpread({}, q, {
    sort: "price"
  })),
      v = qs.stringify(_objectSpread({}, q, {
    sort: "price-desc"
  })),
      w = qs.stringify(_objectSpread({}, q, {
    sort: "frontage-desc"
  })),
      x = qs.stringify(_objectSpread({}, q, {
    sort: "frontage"
  })),
      y = qs.stringify(_objectSpread({}, q, {
    sort: "area"
  })),
      z = qs.stringify(_objectSpread({}, q, {
    sort: "area-desc"
  })),
      A = -1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "results--count",
    style: {
      display: "none"
    }
  }, j.length, " ", /*#__PURE__*/React.createElement("span", null, "results")), /*#__PURE__*/React.createElement("section", {
    ref: b,
    className: "results",
    style: e
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, j.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "results--sorting"
  }, /*#__PURE__*/React.createElement("h4", null, "Sort by"), d ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    to: "".concat(o, "?").concat(w),
    className: classnames({
      active: !r || "frontage-desc" === r
    })
  }, "Frontage High"), /*#__PURE__*/React.createElement(Link, {
    to: "".concat(o, "?").concat(x),
    className: classnames({
      active: "frontage" === r
    })
  }, "Frontage Low"), /*#__PURE__*/React.createElement(Link, {
    to: "".concat(o, "?").concat(z),
    className: classnames({
      active: "area-desc" === r
    })
  }, "Land Size High"), /*#__PURE__*/React.createElement(Link, {
    to: "".concat(o, "?").concat(y),
    className: classnames({
      active: "area" === r
    })
  }, "Land Size Low")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    to: "".concat(o, "?").concat(t),
    className: classnames({
      active: !r || "featured" === r
    })
  }, "Featured"), /*#__PURE__*/React.createElement(Link, {
    to: "".concat(o, "?").concat(u),
    className: classnames({
      active: "price" === r
    })
  }, "Lowest Price"), /*#__PURE__*/React.createElement(Link, {
    to: "".concat(o, "?").concat(v),
    className: classnames({
      active: "price-desc" === r
    })
  }, "Highest Price"))), /*#__PURE__*/React.createElement("div", null, j.map(function (a, b) {
    if (6 === b || 9 < b && 0 == (b + 3) % 9) {
      A++;
      var c = a.slug + b;
      return [/*#__PURE__*/React.createElement(Advertising, {
        key: "".concat(c, "-ad"),
        className: "package ad",
        query: [{
          type: "route",
          value: d ? "landforsale.results" : "property.results"
        }, {
          type: "route",
          value: "results"
        }],
        height: 120,
        index: A
      }), /*#__PURE__*/React.createElement(Package, {
        key: c,
        package: a
      })];
    }

    return /*#__PURE__*/React.createElement(Package, {
      key: a.slug + b,
      package: a
    });
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "results--sorting no-results"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "no-results"
  }, "No results"))))));
});
export default Results;